var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.75H10.505M8.6 15H12.4C12.9601 15 13.2401 15 13.454 14.891C13.6422 14.7951 13.7951 14.6422 13.891 14.454C14 14.2401 14 13.9601 14 13.4V6.6C14 6.03995 14 5.75992 13.891 5.54601C13.7951 5.35785 13.6422 5.20487 13.454 5.10899C13.2401 5 12.9601 5 12.4 5H8.6C8.03995 5 7.75992 5 7.54601 5.10899C7.35785 5.20487 7.20487 5.35785 7.10899 5.54601C7 5.75992 7 6.03995 7 6.6V13.4C7 13.9601 7 14.2401 7.10899 14.454C7.20487 14.6422 7.35785 14.7951 7.54601 14.891C7.75992 15 8.03995 15 8.6 15ZM10.75 12.75C10.75 12.8881 10.6381 13 10.5 13C10.3619 13 10.25 12.8881 10.25 12.75C10.25 12.6119 10.3619 12.5 10.5 12.5C10.6381 12.5 10.75 12.6119 10.75 12.75Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.8d80eaf01f7f165ab71fc23dbdeaefff.svg";
export { ForwardRef as ReactComponent };